import type { FaireProductEntity } from "../../entity_types/product";

export const p_hz9tad5sdf: FaireProductEntity = {
  token: "p_hz9tad5sdf",
  type: "product",
  name: "Cake Slice Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/c1d51c2eb8befdd02c35466e190bd5bb17f82c2be5bd3892aa4ac94ce263a034.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d23bb12c830f948d4bfbffd9f75d8f57f6282d1de21df80462b352616bbb0dc.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png",
    "https://cdn.faire.com/fastly/80238f44183a86fc3c93c48a848c2bb44cfa97a575cf34ce7a2eaa63036155f7.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:09.578Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
